import remotePatterns from '../../public/remote-patterns.json';

/**
 * TODO: Change this file to use the remote configuration
 * @see https://gist.github.com/jihchi/bbc718366fbb6342e0a48045f18c82e5
 * Be careful on not leak non public values to the client
 */

export const dynamic = 'force-dynamic';

const fullConfig = {
  environment: process.env.STAGE || 'dev',
  host: process.env.NEXT_PUBLIC_HOST || 'https://peoople.app',
  api: process.env.NEXT_PUBLIC_API || 'https://api.peoople.app',
  graphql: process.env.NEXT_PUBLIC_GRAPHQL_API || 'https://api-graphql.peoople.app/graphql',
  map: {
    key: 'AIzaSyA5MHp-p6KoAaAiWHK1H3K0BANIXgQNYRM',
  },
  gtm: process.env.NEXT_PUBLIC_GTM_ID || 'GTM-KF7LB5HC',
  images: {
    api: process.env.NEXT_PUBLIC_IMAGES_API || 'https://images.couds.dev/images', // Temporal domain until we have a new doamin from peoople
    remotePatterns,
  },
  gfk: {
    media: process.env.NEXT_PUBLIC_GFK_MEDIA || 'PeoopleWeb',
    // TODO: After GFK validate the implementation, add env NEXT_PUBLIC_GFK_HOST with //es-config.sensic.net/s2s-web.js
    // to the cluster
    url: process.env.NEXT_PUBLIC_GFK_HOST || '//es-config-preproduction.sensic.net/s2s-web.js',
  },
  server: {
    graphql: process.env.GRAPHQL_API,
    self: process.env.CURRENT_HOST || 'http://localhost:3000',
    ratelimit: {
      limit: parseInt(process.env.RATELIMIT_LIMIT || '20', 10),
      interval: parseInt(process.env.RATELIMIT_INTERVAL || '60', 10),
      whitelist: (process.env.RATELIMIT_WHITELIST_IP
        ? JSON.parse(Buffer.from(process.env.RATELIMIT_WHITELIST_IP, 'base64').toString('utf8'))
        : ['127.0.0.1']) as string[],
    },
    cloudflare: {
      turnstile: {
        secret: process.env.TURNSTILE_SECRET || '',
        sitekey: process.env.TURNSTILE_SITEKEY || '',
      },
    },
    login: {
      cookie: 'ppl-tk',
    },
    apikey: process.env.API_KEY,
    sitemap: {
      size: parseInt(process.env.SITEMAP_SIZE || '25000', 10),
    },
    oauth: {
      google: {
        id: process.env.GOOGLE_CLIENT_ID,
        secret: process.env.GOOGLE_CLIENT_SECRET,
      },
      facebook: {
        id: process.env.FB_CLIENT_ID,
        secret: process.env.FB_CLIENT_SECRET,
      },
    },
    hermes: {
      key: process.env.HERMES_KEY || '',
    },
    cache: {
      host: process.env.CACHE_HOST || 'localhost',
      port: process.env.CACHE_PORT || '6379',
      mode: process.env.CACHE_MODE,
      hosts: (process.env.CACHE_HOSTS || '').split(','),
    },
  },
};

const getClientConfig = () => {
  const { content }: any = document.head.querySelector('[name="peoople:config"]') || {};
  if (content) {
    return JSON.parse(content);
  }
  const { server, ...conf } = fullConfig;
  return conf;
};

const configuration = typeof window !== 'undefined' ? getClientConfig() : fullConfig;

export default configuration as typeof fullConfig;
